import { useQuery } from "@tanstack/react-query";
import rolePermissionService from "../api/rolePermissionService";

export const useRolePermissions = () => {
  const { getRolePermissions } = rolePermissionService();

  return useQuery({
    queryKey: ["get-role-permissions"],
    queryFn: async () => {
      const res = await getRolePermissions();
      return res.data;
    },
  });
};

export const useRolePermissionsByRoleId = (roleId) => {
  const { getRolePermissionsByRoleId } = rolePermissionService();

  return useQuery({
    queryKey: ["get-role-permissions-by-roleid", roleId],
    queryFn: async () => {
      const res = await getRolePermissionsByRoleId(roleId);
      return res.data;
    },
    enabled: !!roleId,
  });
};
